<template>
    <div class="content">
        <div class="button">
            <van-field
                    v-model="titleTime"
                    placeholder="选择时间" readonly="readonly"
                    @click="dateShow = true"
            />
            选择日期

          <div class="table-box">
            <table width="100%">
              <tr>
                <td style="text-align:left;word-break:break-all;">
                  <van-cell title="提交总数" v-if="saasDetail.page" :value="saasDetail.page.length"/>
                  </td>

              </tr>

              <tr  v-for="(item, key) of countMap" :key="key">
                <td style="text-align:left;word-break:break-all;">
                  <van-cell :title="key" :value="item"/>
                </td>


              </tr>
            </table>

          </div>
            <div class="table-box" v-if="saasDetail.page&&saasDetail.page.length>0">
                <table width="100%">
                    <tr v-for="(row,index) in saasDetail.page" :key="row.id">
                        <td style="text-align:left;word-break:break-all;">
                            <van-cell title="时间" :value="row.orderTime"/>
                            <van-cell title="姓名" :value="row.name"/>
                            <van-cell title="号码" :value="row.phone"/>
                            <van-cell title="状态" :value="row.statusTop"/>
                        </td>
                    </tr>
                </table>
            </div>
            <van-popup v-model="dateShow" position="bottom">
                <van-datetime-picker v-model="currentDate" type="date" @cancel="handleCancel"
                                     @confirm="handleEndDateConfirm"/>
            </van-popup>
        </div>

        <van-dialog title="更多详情" v-model="dialogVisible" :closeOnClickOverlay="true" style = "height: 85%; overflow-y: scroll;">
            <table style="width:100%;">
                <td style="text-align:left;word-break:break-all;">
                    <van-cell title="订单号" :value="dialogData.orderNumber"/>
                    <van-cell title="收货人姓名" :value="dialogData.receiver"/>
                    <van-cell title="身份证号" :value="dialogData.idCard"/>
                    <van-cell title="地址" :value="dialogData.address"/>
                    <van-cell title="所选号码" :value="dialogData.choosePhone"/>
                    <van-cell title="二级商户名称" :value="dialogData.ename"/>
                    <van-cell title="物流公司" :value="dialogData.logisticsCompany"/>
                    <van-cell title="发货时间" :value="dialogData.deliverTime"/>
                    <van-cell title="下单时间" :value="dialogData.createTime"/>
                </td>
            </table>
        </van-dialog>
    </div>

</template>

<script>
    import countAPI from '@/api/count'

    export default {
        data() {
            return {
                query: {
                    jobId: this.$route.query.jobId,
                    linkId: this.$route.query.linkId,
                    type: this.$route.query.type
                },
                dateShow: false,
                currentDate: new Date(),
                titleTime: "",
                saasDetail: {},
                dialogVisible: false,
                dialogData: {},
                countMap:{}
            }
        },
        methods: {
            handleCancel() {
                this.dateShow = false;
            },
            //开始时间
            handleEndDateConfirm() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.querySaasDetail();
            },
            timeFormat(datetime) { // 时间格式化 2019-09-08
                let year = datetime.getFullYear();
                let month = (datetime.getMonth() + 1) < 10 ? "0" + (datetime.getMonth() + 1) : (datetime.getMonth() + 1);
                let date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                let hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                let minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                let second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                //return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
                return year + "-" + month + "-" + date;
            },
            querySaasDetail() {
                this.$toast.loading({forbidClick: true});
                let queryObj = {};

                queryObj.jobId = this.query.jobId;
                queryObj.ext1 = this.titleTime;
                queryObj.ext2 = this.query.linkId;
                queryObj.ext3 = this.query.type;

                countAPI.saasCommonDetail(queryObj).then((result) => {
                    this.saasDetail = result.data;
                    if(this.saasDetail&&this.saasDetail.page.length>0){

                      for(var j=0;j<this.saasDetail.page.length;j++){
                          var s= this.saasDetail.page[j].statusTop;
                          if(!this.countMap[s]){
                            this.countMap[s]=1
                          }else{
                            this.countMap[s]=this.countMap[s]+1
                          }

                      }
                    }



                    console.log(this.countMap)

                    this.$toast.clear()
                })
            },
            openDialog(row) {
                this.dialogVisible = true;
                this.dialogData = row;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .content {
        padding-top: 2rem;
    }

    .button {
        background-color: #fff;
        margin: 2rem 5%;
        height: 3rem;
        border-radius: 2rem;
        text-align: center;
        line-height: 3rem;
    }

</style>
